import { FC } from 'react'
import { Link } from 'react-router'
import { Languages } from './Languages'
import { toAbsoluteUrl } from '../../../helpers'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../app/redux/store'
import { logoutSession } from '../../../../app/redux/auth/authSlice'
import { AppDispatch } from '../../../../app/redux/store'
import { useIntl } from 'react-intl'

const HeaderUserMenu: FC = () => {
  const intl = useIntl()
  const dispatch = useDispatch<AppDispatch>();
  const currentClient = useSelector((state: RootState) => state.auth.currentClient);

  const handleLogout = () => {
    dispatch(logoutSession());
  };

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('media/avatars/blank.png')} />
          </div>

          <div className='fw-bolder d-flex align-items-center text-uppercase overflow-hidden text-nowrap text-truncate mw-150px' title={currentClient?.userName}>
            {currentClient?.userName}
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/profile'} className='menu-link px-5'>
          {intl.formatMessage({ id: 'MENU.PROFILE' })}
        </Link>
      </div>

      <Languages />

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <button type='button' onClick={handleLogout} className='menu-link px-5 border-0 bg-transparent w-100 text-start'>
          {intl.formatMessage({ id: 'HEADER_USER_MENU.SIGN_OUT' })}
        </button>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
